import React, { useState } from 'react';
import { SlideFromRightWrapper } from '../components/common/SlideFromRightWrapper';
import {
    CreateReferalDataWithPatientData,
    CreateReferalRecivedDataWithPatientData,
} from './PatientReferralDashboard';
import { AntTooltip } from '../components/common/AntTooltip';
import { List } from 'antd';
import VirtualList from 'rc-virtual-list';

const DoctorNetwork: React.FC<{
    referralGivenData?: CreateReferalDataWithPatientData[];
    referralReceivedData?: CreateReferalRecivedDataWithPatientData[];
}> = ({ referralGivenData, referralReceivedData }) => {
    const [isDoctorNetworkSliderOpen, setIsDoctorNetworkSliderOpen] = useState(false);

    const openSliderNetwork = () => {
        setIsDoctorNetworkSliderOpen(true);
    };

    const closeSliderNetwork = () => {
        setIsDoctorNetworkSliderOpen(false);
    };

    const docNetworkObject: {
        [k: string]: {
            referralGivenCount?: number;
            referralReceivedCount?: number;
            name?: string;
            mobile?: string;
        };
    } = {};

    if (referralGivenData) {
        referralGivenData.forEach((refer) => {
            if (refer.referred_doctor_oid) {
                docNetworkObject[refer.referred_doctor_oid] = {
                    referralGivenCount:
                        (docNetworkObject?.[refer?.referred_doctor_oid]?.referralGivenCount || 0) +
                        1,
                    name: [refer?.doc?.[0]?.name?.f, refer?.doc?.[0]?.name?.l]
                        .filter(Boolean)
                        .join(' '),
                    mobile: refer?.doc?.[0]?.phone?.value,
                };
            } else {
                const key = `local-${refer?.doc?.[0]?.phone?.value}#${[
                    refer?.doc?.[0]?.name?.f,
                    refer?.doc?.[0]?.name?.l,
                ]
                    .filter(Boolean)
                    .join(' ')}`;

                docNetworkObject[key] = {
                    referralGivenCount: (docNetworkObject?.[key]?.referralGivenCount || 0) + 1,
                    name: [refer?.doc?.[0]?.name?.f, refer?.doc?.[0]?.name?.l]
                        .filter(Boolean)
                        .join(' '),
                    mobile: refer?.doc?.[0]?.phone?.value,
                };
            }
        });
    }

    if (referralReceivedData) {
        referralReceivedData.forEach((refer) => {
            if (refer.docid) {
                docNetworkObject[refer.docid] = {
                    ...docNetworkObject[refer.docid],
                    referralReceivedCount:
                        (docNetworkObject?.[refer.docid]?.referralReceivedCount || 0) + 1,
                    name:
                        refer.type === 'pt-refer'
                            ? refer?.doc_name
                            : docNetworkObject[refer.docid]?.name ||
                              [
                                  refer?.referral_given_doc_profile?.profile?.personal?.name?.f,
                                  refer?.referral_given_doc_profile?.profile?.personal?.name?.l,
                              ]
                                  .filter(Boolean)
                                  .join(' '),
                    mobile:
                        refer.type === 'pt-refer'
                            ? refer?.doc_phone
                            : refer?.referral_given_doc_profile?.profile?.personal?.phone?.value,
                };
            }
        });
    }

    return (
        <>
            <button
                onClick={openSliderNetwork}
                className="px-15 py-6 rounded-8 flex items-center space-x-8 border border-darwin-accent-bright-blue-800"
            >
                <span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="17"
                        viewBox="0 0 14 17"
                        fill="none"
                    >
                        <path
                            d="M7 2.5C6.09375 2.5 5.28125 3 4.8125 3.75C4.375 4.53125 4.375 5.5 4.8125 6.25C5.28125 7.03125 6.09375 7.5 7 7.5C7.875 7.5 8.6875 7.03125 9.15625 6.25C9.59375 5.5 9.59375 4.53125 9.15625 3.75C8.6875 3 7.875 2.5 7 2.5ZM3 5C3 3.59375 3.75 2.28125 5 1.5625C6.21875 0.84375 7.75 0.84375 9 1.5625C10.2188 2.28125 11 3.59375 11 5C11 6.4375 10.2188 7.75 9 8.46875C7.75 9.1875 6.21875 9.1875 5 8.46875C3.75 7.75 3 6.4375 3 5ZM5 12.0312V13.5938C5.71875 13.8125 6.25 14.4688 6.25 15.25C6.25 16.2188 5.4375 17 4.5 17C3.53125 17 2.75 16.2188 2.75 15.25C2.75 14.4688 3.25 13.8125 4 13.5938V12.3125C2.53125 12.9062 1.5 14.3438 1.5 16V16.25C1.5 16.6875 1.15625 17 0.75 17C0.3125 17 0 16.6875 0 16.25V16C0 12.9688 2.4375 10.5 5.5 10.5H8.5C11.5312 10.5 14 12.9688 14 16V16.25C14 16.6875 13.6562 17 13.25 17C12.8125 17 12.5 16.6875 12.5 16.25V16C12.5 14.3438 11.4375 12.9062 10 12.3125V13.5625C10.8438 13.8125 11.5 14.5938 11.5 15.5V16.5C11.5 16.7812 11.25 17 11 17H10.25C9.96875 17 9.75 16.7812 9.75 16.5C9.75 16.25 9.96875 16 10.25 16H10.5V15.5C10.5 14.9688 10.0312 14.5 9.5 14.5C8.9375 14.5 8.5 14.9688 8.5 15.5V16H8.75C9 16 9.25 16.25 9.25 16.5C9.25 16.7812 9 17 8.75 17H8C7.71875 17 7.5 16.7812 7.5 16.5V15.5C7.5 14.5938 8.125 13.8125 9 13.5625V12.0312C8.8125 12.0312 8.65625 12 8.5 12H5.5C5.3125 12 5.15625 12.0312 5 12.0312ZM4.5 14.5C4.0625 14.5 3.75 14.8438 3.75 15.25C3.75 15.6875 4.0625 16 4.5 16C4.90625 16 5.25 15.6875 5.25 15.25C5.25 14.8438 4.90625 14.5 4.5 14.5Z"
                            fill="#215FFF"
                        />
                    </svg>
                </span>
                <span className="font-700 text-darwin-accent-bright-blue-800">
                    My doctor network ({Object.keys(docNetworkObject)?.length})
                </span>
            </button>
            {isDoctorNetworkSliderOpen && (
                <SlideFromRightWrapper closeMe={closeSliderNetwork} cssClass="w-70p">
                    <div className="bg-darwin-neutral-50 flex flex-col h-full space-between w-full">
                        <div className="flex items-center space-x-16 p-16 pb-24 cursor-pointer">
                            <div
                                onClick={closeSliderNetwork}
                                className="flex items-center justify-center w-16 h-16"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="w-16 h-16 fill-darwin-neutral-1000"
                                >
                                    <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                </svg>
                            </div>
                            <p className="text-darwin-neutral-1000 heading-2 bold">
                                Doctor Network
                            </p>
                        </div>

                        {/* table here */}
                        <div className="h-full w-full flex flex-col bg-white">
                            <div className="flex items-center w-full bg-darwin-neutral-100">
                                <div className="w-10p px-16 py-12">S. No.</div>
                                <div className="w-30p px-16 pl-24 py-12">Doctor name</div>
                                <div className="w-30p px-16 py-12">Contact Number</div>
                                <div className="w-30p px-16 py-12">Referrals received</div>
                                <div className="w-30p px-16 py-12">Referrals given</div>
                            </div>
                            <div className="flex-1 relative h-full w-full">
                                <div className="absolute inset-0 w-full overflow-scroll">
                                    <div className="overflow-hidden">
                                        <List className="overflow-hidden">
                                            <VirtualList
                                                className="hide-scrollbar overflow-auto"
                                                data={Object.keys(docNetworkObject)}
                                                itemHeight={48}
                                                itemKey="refer-data"
                                            >
                                                {(id, i) => {
                                                    const refer = docNetworkObject[id];

                                                    return (
                                                        <List.Item key={i} className="bg-white p-0">
                                                            <div className="flex items-center w-full">
                                                                <div className="w-10p px-16 py-12">
                                                                    {i + 1}
                                                                </div>
                                                                <div className="flex items-center w-30p px-16 py-12 space-x-8">
                                                                    <img
                                                                        src={`https://a.eka.care/doctor-avatar/${id}`}
                                                                        className="h-32 w-32 object-cover rounded-full overflow-hidden"
                                                                        alt=""
                                                                    />

                                                                    <div className="flex items-center">
                                                                        {refer?.name}
                                                                    </div>

                                                                    {id?.startsWith('local-') ||
                                                                    id?.startsWith('locale-') ? (
                                                                        <></>
                                                                    ) : (
                                                                        <div className="w-16 h-16 mr-4">
                                                                            <AntTooltip
                                                                                placement="left"
                                                                                content="Doctor is on Eka network"
                                                                            >
                                                                                <p className="cursor-pointer">
                                                                                    <svg
                                                                                        className="w-16 h-16"
                                                                                        viewBox="0 0 105 117"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            d="M104.436 33.768C104.144 38.8643 102.1 43.6607 98.4497 47.408L63.4061 83.3816C62.53 84.2809 61.5079 85.1803 60.3398 85.9297C52.3089 91.4757 41.3578 90.4264 34.4951 83.3816C30.2607 79.0348 28.0704 72.8893 28.6545 66.5939C28.8005 62.8467 31.8668 59.9988 35.5172 59.9988C39.3136 59.9988 42.3799 63.1464 42.3799 67.0436C42.3799 69.142 41.5038 70.9407 40.1897 72.2897C40.6277 73.4889 41.3578 74.688 42.3799 75.5873C44.1321 77.386 46.6143 78.4352 49.0966 78.4352C50.7028 78.4352 52.1629 78.1354 53.4771 77.386C54.3531 76.9363 55.0832 76.3368 55.8133 75.5873L73.0431 57.9003L65.8883 50.5557L55.6673 40.0634C53.9151 38.2647 51.4328 37.2155 48.9506 37.2155C46.4683 37.2155 43.9861 38.2647 42.2339 40.0634C41.0658 41.2625 40.1897 42.7614 39.7516 44.2603C41.3578 45.6093 42.5259 47.5579 42.5259 49.8062C42.5259 53.7034 39.4596 56.8511 35.6632 56.8511C32.1589 56.8511 29.0925 54.0032 28.8005 50.4058C27.6324 43.6607 29.6766 36.9157 34.4951 31.9693C38.2915 28.0722 43.402 25.8238 48.9506 25.8238C54.3531 25.8238 59.6097 28.0722 63.4061 31.9693L73.6271 42.4616L80.7819 49.8062L90.7109 39.6137C92.6091 37.6651 93.4852 35.2669 93.4852 32.5689C93.4852 30.1706 92.6091 27.9223 91.0029 26.2735C86.7685 21.477 81.658 17.7298 75.9634 15.0318C69.9768 12.3337 63.6981 10.8348 57.1274 10.8348C44.8622 10.8348 33.473 15.7812 24.7121 24.6247C16.0972 33.4682 11.2787 45.3095 11.2787 57.9003C11.2787 70.4911 16.0972 82.1825 24.7121 91.1759C33.327 100.019 44.8622 104.966 57.1274 104.966C63.6981 104.966 69.9768 103.617 75.9634 100.769C81.658 98.0708 86.7685 94.3236 91.0029 89.5271C94.3613 85.6299 94.2152 79.7842 90.7109 76.037L83.4101 68.5425L91.1489 60.5983L98.4497 68.0928C106.188 76.037 106.481 88.6277 99.1798 97.0216C93.9232 103.017 87.6446 107.664 80.6359 110.961C73.3351 114.409 65.4503 116.058 57.2734 116.058C49.6807 116.058 42.2339 114.559 35.2252 111.561C28.5085 108.563 22.3758 104.366 17.2653 99.12C12.0088 93.724 7.92036 87.5785 5.14608 80.6836C2.22578 73.4889 0.765625 65.8445 0.765625 58.0502C0.765625 50.2559 2.22578 42.6115 5.14608 35.4168C8.06638 28.5219 12.1548 22.2265 17.2653 16.9803C22.5219 11.5843 28.5085 7.38737 35.2252 4.53946C42.2339 1.54166 49.6807 0.042762 57.2734 0.042762C65.4503 0.042762 73.1891 1.84143 80.6359 5.13901C87.7906 8.43659 93.9232 13.0832 99.1798 19.0788C101.37 21.6269 103.122 24.7746 103.852 28.0722C104.29 29.4212 104.436 31.6695 104.436 33.768Z"
                                                                                            fill="#7265E3"
                                                                                        ></path>
                                                                                    </svg>
                                                                                </p>
                                                                            </AntTooltip>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="w-30p px-16 py-12">
                                                                    {refer?.mobile || '----'}
                                                                </div>
                                                                <div className="w-30p px-15 py-12 text-14">
                                                                    {refer?.referralReceivedCount ||
                                                                        0}
                                                                </div>
                                                                <div className="w-30p px-15 py-12 text-14">
                                                                    {refer?.referralGivenCount || 0}
                                                                </div>
                                                            </div>
                                                        </List.Item>
                                                    );
                                                }}
                                            </VirtualList>
                                        </List>
                                        <div className="h-100"></div>
                                    </div>

                                    <style>
                                        {`
                        .ant-popover-inner-content {
                            padding: 0px
                        }
                        `}
                                    </style>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center justify-between absolute rounded-8 bg-actionPrimary bottom-24 inset-x-10 px-16 py-8 cta-row">
                            <button
                                onClick={closeSliderNetwork}
                                className="text-btn-v2 px-16 py-8 btn--small"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </SlideFromRightWrapper>
            )}
        </>
    );
};

export default DoctorNetwork;
